import Api from '../Api';
import axios from 'axios';
import { compatibleApiVersion } from '../../package.json';

/**
 * @return {{
 *  next_mandatory_refresh: number, // utc timestamp.
 *  playlists: {
 *      zone_id: number,
 *      resume_playing_from: number,
 *      widgets: {
 *          duration: number, // lifetime of widget in milliseconds.
 *          type: string, // unique slug of widget type.
 *          settings: object // widget specific settings.
 *      }[]
 *  }[]}
 * }
 */
export const getPlaylist = async (screenId, isPreview) => {
    if (screenId.indexOf('demo-') === 0) {
        const response = await axios.get(`/fixtures/${screenId}.json`);
        const playlist = await response.data.playlist;
        playlist.version = compatibleApiVersion;
        return playlist;
    }

    const previewParam = isPreview ? '&preview=1' : '';
    const response = await Api.get(`/site/screen-content?screen_id=${screenId}${previewParam}`);
    return await response.data;
};
